exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".tab-content select.form-control {\r\n    position: relative;\r\n    z-index: 0 !important;\r\n}\r\n\r\n.navbar-brand {\r\n    height: 84px;\r\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./app/Register/Template/Registration.css
// module id = 526
// module chunks = 3